import { useState, useEffect } from "react";
import { fetchWrapper } from "src/api-client/fetchWrapper";

export const useCurrentRemittanceInfo = () => {
  const [loader, setLoader] = useState(false);
  const [currentRemittanceData, setCurrentRemittanceData] = useState<any>(null);

  async function getCurrentRemittanceData() {
    setLoader(true);
    const FETCH_REMIT_ENDPOINT = `get-vendor-remit_details_by_id`;
    try {
      const data = await fetchWrapper.get(FETCH_REMIT_ENDPOINT);
      if (data && data.remitDetails) {
        setCurrentRemittanceData(data.remitDetails);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  }

  useEffect(() => {
    getCurrentRemittanceData();
  }, []);

  return {
    loader,
    currentRemittanceData,
    getCurrentRemittanceData,
  };
};
